import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Payment } from 'src/app/_models/payment';
import { PaymentService } from 'src/app/_services/payment.service';

@Component({
    selector: 'app-payment-detail',
    templateUrl: './payment-detail.component.html',
    styleUrls: ['./payment-detail.component.css'],
    standalone: false
})
export class PaymentDetailComponent implements OnInit {
    payment: Payment;
    paymentId: string;
    loading = true;
    updating = false;

    constructor(
        private paymentService: PaymentService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private toast: ToastrService
    ) {
        this.paymentId = this.activatedRoute.snapshot.paramMap.get('id') ?? '';
    }

    ngOnInit(): void {
        if (!this.paymentId) {
            this.toast.error('Payment ID is required');
            this.router.navigate(['/admin/payments']);
            return;
        }
        this.loadPayment();
    }

    loadPayment(): void {
        this.loading = true;
        this.paymentService.loadPayment(this.paymentId).subscribe({
            next: (response) => {
                this.payment = response.data;
            },
            error: (err) => {
                console.error('Failed to load payment', err);
                if (err?.status !== 401 && err?.status !== 403) {
                    this.toast.error('Failed to load payment details');
                }
                this.router.navigate(['/admin/payments']);
            },
            complete: () => {
                this.loading = false;
            }
        });
    }

    changeStatus(status: string): void {
        this.updating = true;
        this.paymentService.changePaymentStatus(this.paymentId, status).subscribe({
            next: () => {
                this.updating = false;
                this.toast.success(`Payment status updated to ${status}`);
                this.loadPayment();
            },
            error: (err) => {
                this.updating = false;
                console.error('Failed to update payment status', err);
                if (err?.status !== 401 && err?.status !== 403) {
                    this.toast.error('Failed to update payment status');
                }
            }
        });
    }

    goBack(): void {
        this.router.navigate(['/admin/payments']);
    }
}
